import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { reminderPolicyKeys } from '@/lib/queryKeys';
import type { ReminderPolicy, ReminderType } from '@/types/reminder-policy';

/**
 * Fetches a single `ReminderPolicy` by `ReminderType` for the current tenant.
 *
 * Backend: `GET /v2/reminder-policies/:type` →
 * `apps/operations/src/modules/reminders/policy/reminder-policy.controller.ts#get`.
 */
export function useReminderPolicy(type: ReminderType | undefined) {
  return useApiQuery<ReminderPolicy>({
    queryKey: reminderPolicyKeys.detail(type ?? '__none__'),
    queryFn: () =>
      apiGet<ReminderPolicy>(operationsClient, endpoints.reminderPoliciesV2.detail(type as string)),
    enabled: Boolean(type),
    showErrorToast: false,
  });
}
